/** * Componente de navegação em breadcrumb * Exibe o caminho de navegação atual do usuário * *
Features: * - Navegação hierárquica * - Internacionalização * - Responsividade * - Integração com
vue-router */

<template>
    <div
        class="bread-menu"
        v-if="mostrarMenu"
    >
        <template
            v-for="(item, index) in itensCaminho"
            :key="index"
        >
            <router-link
                v-if="!item.atual"
                :to="item.rota"
            >
                <p>{{ t(item.texto, item.params) }}</p>
            </router-link>
            <p
                v-else
                class="current"
            >
                {{ t(item.texto, item.params) }}
            </p>
            <Circle
                v-if="index < itensCaminho.length - 1"
                class="circle-icon"
                :size="8"
            />
        </template>
    </div>
</template>

<script lang="ts">
    import { defineComponent, computed } from 'vue'
    import { useRoute } from 'vue-router'
    import { useI18n } from 'vue-i18n'
    import Circle from 'vue-material-design-icons/Circle.vue'
    import { useNavigationStore } from '@/stores/navigation'

    export default defineComponent({
        name: 'NavMenu',

        components: {
            Circle,
        },

        setup() {
            const rota = useRoute()
            const { t, locale } = useI18n()
            const navigationStore = useNavigationStore()

            const mapeamentoRotas = {
                '/dashboard/modules/receipt': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { texto: 'nav_menu.receipt', atual: true },
                ],
                '/dashboard/modules/receipt/newreceipt': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { rota: '/dashboard/modules/receipt', texto: 'nav_menu.receipt' },
                    { texto: 'nav_menu.new_receipt', atual: true },
                ],
                '/dashboard/config/company': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { rota: '/dashboard/config', texto: 'nav_menu.config' },
                    { texto: 'nav_menu.companies', atual: true },
                ],
                '/dashboard/config': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { texto: 'nav_menu.config', atual: true },
                ],
                '/dashboard/travel': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { texto: 'nav_menu.travel', atual: true },
                ],
                '/dashboard/travel/new': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { rota: '/dashboard/travel', texto: 'nav_menu.travel' },
                    { texto: 'nav_menu.new_travel', atual: true },
                ],
                '/dashboard/travel-approvals': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { texto: 'nav_menu.travel_control', atual: true },
                ],
                '/dashboard/config/mytools': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { rota: '/dashboard/config', texto: 'nav_menu.config' },
                    { texto: 'nav_menu.my_tools', atual: true },
                ],
                '/dashboard/config/mytools/mytoolsbuy': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { rota: '/dashboard/config', texto: 'nav_menu.config' },
                    { rota: '/dashboard/config/mytools', texto: 'nav_menu.my_tools' },
                    { texto: 'nav_menu.get_tools', atual: true },
                ],
                '/dashboard/profile': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { texto: 'nav_menu.profile', atual: true },
                ],
                '/dashboard/config/user': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { rota: '/dashboard/config', texto: 'nav_menu.config' },
                    { texto: 'nav_menu.users', atual: true },
                ],
                '/dashboard/config/admtools': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { rota: '/dashboard/config', texto: 'nav_menu.config' },
                    { texto: 'nav_menu.my_tools', atual: true },
                ],
                '/dashboard/config/voucher': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { rota: '/dashboard/config', texto: 'nav_menu.config' },
                    { texto: 'nav_menu.vouchers', atual: true },
                ],
                '/dashboard/modules/management': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { texto: 'nav_menu.management', atual: true },
                ],
                '/dashboard/config/company/projects': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { rota: '/dashboard/config', texto: 'nav_menu.config' },
                    { rota: '/dashboard/config/company', texto: 'nav_menu.companies' },
                    { texto: 'nav_menu.projects', atual: true },
                ],
                '/dashboard/config/company/cost-center': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { rota: '/dashboard/config', texto: 'nav_menu.config' },
                    { rota: '/dashboard/config/company', texto: 'nav_menu.companies' },
                    { texto: 'nav_menu.cost_center', atual: true },
                ],
                '/dashboard/config/users': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { rota: '/dashboard/config', texto: 'nav_menu.config' },
                    { texto: 'nav_menu.users', atual: true },
                ],
                '/dashboard/financial-control/payments': [
                    { rota: '/dashboard/', texto: 'nav_menu.dashboard' },
                    { texto: 'nav_menu.financial-control', atual: true },
                ],
                '/dashboard/financial-control/myreleases/new': [
                    { rota: '/dashboard/', texto: 'nav_menu.dashboard' },
                    {
                        rota: '/dashboard/financial-control/payments',
                        texto: 'nav_menu.financial-control',
                    },
                    { texto: 'nav_menu.myreleases', atual: true },
                ],
                '/dashboard/financial-control/approvals': [
                    { rota: '/dashboard/', texto: 'nav_menu.dashboard' },
                    { texto: 'nav_menu.financial-control', atual: true }, // "Aprovações"
                ],
                '/dashboard/financial-control/payer': [
                    { rota: '/dashboard/', texto: 'nav_menu.dashboard' },
                    { texto: 'nav_menu.payments', atual: true }, // "Pagamentos"
                ],
                '/dashboard/events': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { texto: 'nav_menu.events', atual: true },
                ],
                '/dashboard/events/new': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { rota: '/dashboard/events', texto: 'nav_menu.events' },
                    { texto: 'nav_menu.new_event', atual: true },
                ],
                '/dashboard/bobinas-gerenciar': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { texto: t('nav_menu.coils'), atual: true },
                ],
                '/dashboard/bobinas-consulta': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { texto: 'Estoque de Bobinas', atual: true },
                ],
                '/dashboard/bobinas-painel': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { rota: '/dashboard/bobinas-consulta', texto: 'Estoque de Bobinas' },
                    { texto: 'Painel Operacional', atual: true },
                ],
                '/dashboard/estoque-gerenciar': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { rota: '/dashboard/bobinas-consulta', texto: 'Estoque de Bobinas' },
                    { texto: 'Estoque', atual: true },
                ],
                '/dashboard/bobinas-painel-interno': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { rota: '/dashboard/bobinas-consulta', texto: 'Estoque de Bobinas' },
                    { texto: 'Painel Operacional', atual: true },
                ],
                '/dashboard/config/paineis': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { rota: '/dashboard/config', texto: 'nav_menu.config' },
                    { texto: 'Painéis', atual: true },
                ],
                '/dashboard/config/external-config': [
                    { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                    { rota: '/dashboard/config', texto: 'nav_menu.config' },
                    { rota: '/dashboard/config/company', texto: 'nav_menu.companies' },
                    { texto: 'Configurações Externas', atual: true },
                ],
            }

            /**
             * Remove prefixo de idioma da rota
             * @param {string} rota - Rota completa
             * @returns {string} Rota normalizada sem prefixo de idioma
             */
            const normalizarRota = (rota: string): string => {
                const partes = rota.split('/')
                if (partes.length > 1 && partes[1].length === 2) {
                    partes.splice(1, 1)
                }
                return partes.join('/')
            }

            /**
             * Adiciona prefixo de idioma à rota
             * @param {string} rota - Rota base
             * @returns {string} Rota com prefixo de idioma atual
             */
            const obterRotaComIdioma = (rota: string): string => {
                const rotaNormalizada = normalizarRota(rota)
                return `/${locale.value}${rotaNormalizada}`
            }

            const mostrarMenu = computed(() => {
                const rotaAtual = normalizarRota(rota.path)

                const rotaDinamicaEmpresa = /^\/dashboard\/config\/company\/\d+$/.test(rotaAtual)

                const rotaDinamicaViagem = /^\/dashboard\/travel\/edit\/.+$/.test(rotaAtual)

                const rotaDinamicaApprover = /^\/dashboard\/travel-approvals\/view\/.+$/.test(
                    rotaAtual,
                )

                const rotaDinamicaMyrealeases =
                    /^\/dashboard\/financial-control\/myreleases\/edit\/.+$/.test(rotaAtual)

                const rotaDinamicaProjetos = /^\/dashboard\/config\/company\/projects\/\d+$/.test(
                    rotaAtual,
                )
                const rotaDinamicaCentroCusto =
                    /^\/dashboard\/config\/company\/cost-center\/\d+$/.test(rotaAtual)

                const rotaDinamicaEditarEvento = /^\/dashboard\/events\/edit\/.+$/.test(rotaAtual)

                const rotaDinamicaApproveView =
                    /^\/dashboard\/financial-control\/myreleases\/view_approve\/.+$/.test(rotaAtual)
                const rotaDinamicaPayerView =
                    /^\/dashboard\/financial-control\/myreleases\/view_pay\/.+$/.test(rotaAtual)

                return (
                    rotaAtual !== '/' &&
                    rotaAtual !== '/dashboard' &&
                    (mapeamentoRotas[rotaAtual] ||
                        rotaDinamicaEmpresa ||
                        rotaDinamicaViagem ||
                        rotaDinamicaApprover ||
                        rotaDinamicaMyrealeases ||
                        rotaDinamicaProjetos ||
                        rotaDinamicaCentroCusto ||
                        rotaDinamicaEditarEvento ||
                        rotaDinamicaApproveView ||
                        rotaDinamicaPayerView)
                )
            })

            const itensCaminho = computed(() => {
                const caminho = normalizarRota(rota.path)
                const idEmpresa = rota.params.companyId || rota.params.id

                if (caminho === '/dashboard/config/company' && navigationStore.cameFromUsers) {
                    return [
                        { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                        { rota: '/dashboard/config', texto: 'nav_menu.config' },
                        { rota: '/dashboard/config/users', texto: 'nav_menu.users' },
                        { texto: 'nav_menu.companies', atual: true },
                    ].map((item) => ({
                        ...item,
                        rota: item.rota ? obterRotaComIdioma(item.rota) : undefined,
                    }))
                }

                if (
                    /^\/dashboard\/financial-control\/myreleases\/view_approve\/.+$/.test(caminho)
                ) {
                    const paymentId = (rota.query?.cpid as any) || caminho.split('/').pop() || ''
                    return [
                        { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                        {
                            rota: '/dashboard/financial-control/approvals',
                            texto: 'nav_menu.financial-control',
                        },
                        {
                            texto: 'nav_menu.approve_id',
                            params: { id: paymentId.padStart(6, '0') },
                            atual: true,
                        },
                    ].map((item) => ({
                        ...item,
                        rota: item.rota ? obterRotaComIdioma(item.rota) : undefined,
                    }))
                }

                if (/^\/dashboard\/financial-control\/myreleases\/view_pay\/.+$/.test(caminho)) {
                    const paymentId = (rota.query?.cpid as any) || caminho.split('/').pop() || ''
                    return [
                        { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                        {
                            rota: '/dashboard/financial-control/payer',
                            texto: 'nav_menu.payments',
                        },
                        {
                            texto: 'nav_menu.payment_id',
                            params: { id: paymentId.padStart(6, '0') },
                            atual: true,
                        },
                    ].map((item) => ({
                        ...item,
                        rota: item.rota ? obterRotaComIdioma(item.rota) : undefined,
                    }))
                }
                if (/^\/dashboard\/config\/company\/\d+$/.test(caminho)) {
                    let breadcrumbItems = []

                    if (navigationStore.cameFromUsers) {
                        breadcrumbItems = [
                            { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                            { rota: '/dashboard/config', texto: 'nav_menu.config' },
                            { rota: '/dashboard/config/users', texto: 'nav_menu.users' },
                            { rota: '/dashboard/config/company', texto: 'nav_menu.companies' },
                            { texto: 'nav_menu.edit', atual: true },
                        ]
                    } else {
                        breadcrumbItems = [
                            { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                            { rota: '/dashboard/config', texto: 'nav_menu.config' },
                            { rota: '/dashboard/config/company', texto: 'nav_menu.companies' },
                            { texto: 'nav_menu.edit', atual: true },
                        ]
                    }

                    return breadcrumbItems.map((item) => ({
                        ...item,
                        rota: item.rota ? obterRotaComIdioma(item.rota) : undefined,
                    }))
                }

                if (/^\/dashboard\/financial-control\/myreleases\/edit\/.+$/.test(caminho)) {
                    const paymentId = (rota.query?.cpid as any) || caminho.split('/').pop() || ''
                    return [
                        { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                        {
                            rota: '/dashboard/financial-control/payments',
                            texto: 'nav_menu.financial-control',
                        },
                        {
                            texto: 'nav_menu.myrealeases_id',
                            params: { id: paymentId.padStart(6, '0') },
                            atual: true,
                        },
                    ].map((item) => ({
                        ...item,
                        rota: item.rota ? obterRotaComIdioma(item.rota) : undefined,
                    }))
                }

                if (/^\/dashboard\/travel\/edit\/.+$/.test(caminho)) {
                    const travelId = caminho.split('/').pop() || ''
                    return [
                        { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                        { rota: '/dashboard/travel', texto: 'nav_menu.travel' },
                        {
                            texto: 'nav_menu.travel_id',
                            atual: true,
                        },
                    ].map((item) => ({
                        ...item,
                        rota: item.rota ? obterRotaComIdioma(item.rota) : undefined,
                    }))
                }

                if (/^\/dashboard\/travel-approvals\/view\/.+$/.test(caminho)) {
                    const travelId = caminho.split('/').pop() || ''
                    return [
                        { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                        { rota: '/dashboard/travel-approvals', texto: 'nav_menu.travel_control' },
                        {
                            texto: 'nav_menu.travel_id',
                            atual: true,
                        },
                    ].map((item) => ({
                        ...item,
                        rota: item.rota ? obterRotaComIdioma(item.rota) : undefined,
                    }))
                }

                if (/^\/dashboard\/config\/company\/projects\/\d+$/.test(caminho)) {
                    return [
                        { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                        { rota: '/dashboard/config', texto: 'nav_menu.config' },
                        { rota: '/dashboard/config/company', texto: 'nav_menu.companies' },
                        { rota: `/dashboard/config/company/${idEmpresa}`, texto: 'nav_menu.edit' },
                        { texto: 'nav_menu.projects', atual: true },
                    ].map((item) => ({
                        ...item,
                        rota: item.rota ? obterRotaComIdioma(item.rota) : undefined,
                    }))
                }

                if (/^\/dashboard\/config\/company\/cost-center\/\d+$/.test(caminho)) {
                    return [
                        { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                        { rota: '/dashboard/config', texto: 'nav_menu.config' },
                        { rota: '/dashboard/config/company', texto: 'nav_menu.companies' },
                        { rota: `/dashboard/config/company/${idEmpresa}`, texto: 'nav_menu.edit' },
                        { texto: 'nav_menu.cost_center', atual: true },
                    ].map((item) => ({
                        ...item,
                        rota: item.rota ? obterRotaComIdioma(item.rota) : undefined,
                    }))
                }
                if (/^\/dashboard\/events\/edit\/.+$/.test(caminho)) {
                    return [
                        { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                        { rota: '/dashboard/events', texto: 'nav_menu.events' },
                        { texto: 'nav_menu.edit_event', atual: true },
                    ].map((item) => ({
                        ...item,
                        rota: item.rota ? obterRotaComIdioma(item.rota) : undefined,
                    }))
                }
                if (caminho === '/dashboard/config/external-config') {
                    const companyId = navigationStore.externalConfigCompanyId

                    if (companyId) {
                        return [
                            { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                            { rota: '/dashboard/config', texto: 'nav_menu.config' },
                            { rota: '/dashboard/config/company', texto: 'nav_menu.companies' },

                            {
                                rota: `/dashboard/config/company/${companyId}`,
                                texto: 'nav_menu.edit',
                            },
                            { texto: 'Configurações Externas', atual: true },
                        ].map((item) => ({
                            ...item,
                            rota: item.rota ? obterRotaComIdioma(item.rota) : undefined,
                        }))
                    } else {
                        return [
                            { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                            { rota: '/dashboard/config', texto: 'nav_menu.config' },
                            { rota: '/dashboard/config/company', texto: 'nav_menu.companies' },
                            { texto: 'Configurações Externas', atual: true },
                        ].map((item) => ({
                            ...item,
                            rota: item.rota ? obterRotaComIdioma(item.rota) : undefined,
                        }))
                    }
                }

                if (caminho === '/dashboard/bobinas-painel-interno') {
                    const origem = String(
                        sessionStorage.getItem('dashboard_internal_from') || rota.query?.from || '',
                    ).toLowerCase()

                    const veioDaConfig = origem.includes('config')

                    const breadcrumbItems = veioDaConfig
                        ? [
                              { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                              { rota: '/dashboard/config', texto: 'nav_menu.config' },
                              { texto: 'Painel Operacional', atual: true },
                          ]
                        : [
                              { rota: '/dashboard', texto: 'nav_menu.dashboard' },
                              { rota: '/dashboard/bobinas-consulta', texto: 'Estoque de Bobinas' },
                              { texto: 'Painel Operacional', atual: true },
                          ]

                    return breadcrumbItems.map((item) => ({
                        ...item,
                        rota: item.rota ? obterRotaComIdioma(item.rota) : undefined,
                    }))
                }

                const itens = mapeamentoRotas[caminho] || []

                return itens.map((item) => ({
                    ...item,
                    rota: item.rota ? obterRotaComIdioma(item.rota) : undefined,
                }))
            })

            return {
                mostrarMenu,
                itensCaminho,
                t,
            }
        },
    })
</script>

<style lang="scss" scoped>
    .bread-menu {
        font-size: 1rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 1rem;
        text-transform: capitalize;
        margin-right: 8.4rem;

        :deep(.circle-icon) {
            color: var(--colorOpacity100);
            display: flex;
            align-items: center;
        }

        a {
            text-decoration: none;
            color: #b5aeae;

            &:hover {
                color: #262626;
            }
        }

        .current {
            text-decoration: underline;
            color: #464646;
            font-weight: 700;
        }
    }

    /* Desktop */
    @media only screen and (min-device-width: 800px) and (min-device-height: 600px),
        (max-device-height: 599px) and (orientation: landscape) {
        .bread-menu {
            display: flex;
        }
    }

    /* Mobile e Tablet */
    @media only screen and (max-device-width: 599px) and (orientation: portrait),
        (max-device-height: 799px) and (orientation: portrait) {
        .bread-menu {
            display: none;
        }
    }
</style>
